import i18n from "../translations/i18n";
import axios from "axios";
import { setCachedPopularProducts } from "./popular-products";

const API_ENDPOINT_URL       = '/module/brekz_popular_items/fetch_popular';
const CACHE_LOCALSTORAGE_KEY = 'popular-categories-cached';
const CACHE_TIME_TO_LIVE     = 1000 * 60 * 60 * 24;

function getCachedPopularCategories() {
    const cachedPopularCategoriesJson = localStorage.getItem(CACHE_LOCALSTORAGE_KEY);

    if (! cachedPopularCategoriesJson) {
        // The cache is unavailable, return a cache miss

        return null;
    }

    const cachedPopularCategories = JSON.parse(cachedPopularCategoriesJson);
    const currentTimestamp      = new Date().getTime();

    if (cachedPopularCategories.timestamp + CACHE_TIME_TO_LIVE < currentTimestamp) {
        // The cache is outdated, return a cache miss

        return null;
    }

    return cachedPopularCategories.categories;
}

export function setCachedPopularCategories(categories) {
    const cacheData = {
        timestamp: new Date().getTime(),
        categories: categories
    };

    try {
        localStorage.setItem(CACHE_LOCALSTORAGE_KEY, JSON.stringify(cacheData));
    } catch(e) {
        console.log(e);
    }
}

function getEndpointUrl(){
    if (window.id_shop) {
        switch(window.id_shop) {
            case 8:
                return `/de${API_ENDPOINT_URL}`;
            case 9:
                return `/fr${API_ENDPOINT_URL}`;
            default:
                return API_ENDPOINT_URL;
        }
    }

    return API_ENDPOINT_URL;
}

function getPopularCategories() {
    return new Promise(async (resolve) => {
        try {
            const cachedPopularCategories = getCachedPopularCategories();

            if (cachedPopularCategories && cachedPopularCategories.length) {
                resolve(cachedPopularCategories);

                return;
            }

            const popularCategoriesResponse = await axios.get(getEndpointUrl());

            if (! popularCategoriesResponse.data.categories) {
                resolve([]);

                return;
            }

            setCachedPopularCategories(popularCategoriesResponse.data.categories);
            setCachedPopularProducts(popularCategoriesResponse.data.products);
            resolve(popularCategoriesResponse.data.categories);
        } catch(e) {
            // Return empty results to prevent breaking the search entirely

            resolve([]);
        }
    });
}

export function createPopularCategoriesPlugin(options) {
    return {
        getSources({ query }) {
            return [
                {
                    sourceId: 'popularCategoriesPlugin',
                    getItems() {
                        return getPopularCategories();
                    },
                    templates: {
                        header({ items }) {
                            if (! items.length) {
                                return null;
                            }

                            // todo: Improve styling to be more accurate to the Figma design
                            return (
                                <section className="search-bar-popular">
                                    <p className="search-bar-popular__title">{i18n.global.t("algoliaSearch.popularCategoriesTitle")}:</p>
                                </section>
                            );
                        },
                        item({ item }) {
                            // todo: Improve styling to be more accurate to the Figma design

                            return (
                                <a href={item.category_url} className="search-bar-category__item">
                                    <p>{item.name}</p>
                                </a>
                            );
                        },
                        noResults() {
                            return null;
                        },
                    },
                },
            ];
        },
    };
}
